import { render, staticRenderFns } from "./FarmManager.vue?vue&type=template&id=28b4458d&scoped=true&"
import script from "./FarmManager.vue?vue&type=script&lang=js&"
export * from "./FarmManager.vue?vue&type=script&lang=js&"
import style0 from "./FarmManager.vue?vue&type=style&index=0&id=28b4458d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4458d",
  null
  
)

export default component.exports